"use strict";
// Preserve the existing server-rendered forms; populate only the requested menu.
(() => {
  let countries;
  document.addEventListener("dialog:before-show", event => {
    const popover = event.target;
    if (!(popover instanceof Element) || !popover.matches("x-popover")) return;
    const template = popover.querySelector(":scope > template[data-pc-country-options]");
    if (!template) return;
    if (!countries) {
      const data = document.getElementById("pc-country-options-data-v18");
      if (!data) return;
      try { countries = JSON.parse(data.textContent); } catch { return; }
      if (!Array.isArray(countries) || !countries.length) { countries = null; return; }
    }
    const listbox = template.content.querySelector("x-listbox");
    if (!listbox) return;
    const choices = document.createDocumentFragment();
    for (const [iso, name, currency, symbol, flagURL] of countries) {
      const button = document.createElement("button");
      button.type = "submit";
      button.name = "country_code";
      button.value = iso;
      button.className = "popover__value-option h-stack gap-2.5";
      button.setAttribute("role", "option");
      button.setAttribute("aria-selected", String(iso === template.dataset.currentCountry));
      if (template.dataset.showFlags === "true") {
        const flag = document.createElement("img");
        flag.className = "country-flag";
        flag.loading = "lazy";
        flag.src = flagURL;
        flag.alt = name;
        flag.width = 60;
        flag.height = 45;
        button.append(flag);
      }
      const label = document.createElement("span");
      label.textContent = `${name} (${currency}${symbol ? " " + symbol : ""})`;
      button.append(label);
      choices.append(button);
    }
    listbox.replaceChildren(choices);
    // Children are ready before the theme's listbox connected/focus behavior runs.
    template.replaceWith(template.content);
  }, {capture: true});
})();
